import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SpotGroup } from '../models';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class SpotGroupService extends BaseApiService<SpotGroup> {
  get cacheKey(): StorageKey {
    return StorageKey.spotGroupServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/spotGroups`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected unparse(obj) {
    return SpotGroup.unparse(obj);
  }

  protected parse(obj) {
    return SpotGroup.parse(obj);
  }
}
